module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDkuMTQyODZIOS4xNDI4NlYxNkg2Ljg1NzE0VjkuMTQyODZIMFY2Ljg1NzE0SDYuODU3MTRWMEg5LjE0Mjg2VjYuODU3MTRIMTZWOS4xNDI4NloiIGZpbGw9InZhcigtLXNlY29uZGFyeS1jb2xvci1ob3ZlcikiLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homebase/bookmarks/add-hover.svg
// module id = 1Ctu
// module chunks = 1